import { render } from "./EditaTipsterForm.vue?vue&type=template&id=530f6d88&scoped=true"
import script from "./EditaTipsterForm.vue?vue&type=script&lang=js"
export * from "./EditaTipsterForm.vue?vue&type=script&lang=js"

import "./EditaTipsterForm.vue?vue&type=style&index=0&id=530f6d88&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-530f6d88"]])

export default __exports__